import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useField } from 'react-final-form';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import WithError from '../../../../../components/with-error/WithError';
import { Input } from '../../../../../components/common-inputs';
import { BUTTON_STYLES } from '../../../../../components/common-button/CommonButton';
import TooltipButton from '../../../../../components/tooltip-button/TooltipButton';

import scss from '../Steps.module.scss';

function StepContactInfo() {
  const { t } = useTranslation('contact');

  const currentUserInfo = useSelector((state) => state.securityNew.currentUserInfo);

  const { input: contactEmailInput } = useField('contactEmail');

  const handleUseAccountEmail = () => {
    contactEmailInput.onChange(currentUserInfo.username);
  };

  return (
    <div className={scss.stepFormWrapper}>
      <Field name='contactEmail' type='email' autoComplete='email'>
        {({ meta, input }) => (
          <div className={scss.inputWithButton}>
            <WithLabel label={t('contactEmail')} variant={LABEL_STYLES.COLUMN} isBold isTwoDots isRequired>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} placeholder={t('email')} />
              </WithError>
            </WithLabel>

            <TooltipButton
              styleColor={BUTTON_STYLES.SECONDARY}
              onClick={handleUseAccountEmail}
              maxWidth={36}
              tooltip={t('useAccountEmail')}>
              <PermIdentityIcon className={scss.personIcon} />
            </TooltipButton>
          </div>
        )}
      </Field>
    </div>
  );
}

export default StepContactInfo;
